import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    col1: {
        fill: '#28AAE1',
        fillRule: 'nonzero',
    },
}

const entranceDiSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 732 732" width={width} height={height}>
        <polygon style={ styles.col1 } points="33,700 2,700 2,585 33,585 "/>
        <path style={ styles.col1 }
              d="M113 596c13,0 27,19 27,46 0,27 -14,46 -27,46 -12,0 -27,-19 -27,-46 0,-27 15,-46 27,-46zm0 -15l0 0c-23,0 -42,27 -42,61 0,34 19,62 42,62 24,0 43,-28 43,-62 0,-34 -19,-61 -43,-61z"/>
        <polygon style={ styles.col1 } points="220,700 188,700 188,585 220,585 "/>
        <polygon style={ styles.col1 } points="726,700 694,700 694,585 726,585 "/>
        <polygon style={ styles.col1 } points="273,700 241,700 241,585 273,585 "/>
        <polygon style={ styles.col1 } points="443,700 412,700 412,585 443,585 "/>
        <path style={ styles.col1 }
              d="M348 596c12,0 27,19 27,46 0,27 -15,46 -27,46 -13,0 -27,-19 -27,-46 0,-27 14,-46 27,-46zm0 -15l0 0c-24,0 -43,27 -43,61 0,34 19,62 43,62 23,0 42,-28 42,-62 0,-34 -19,-61 -42,-61z"/>
        <path style={ styles.col1 }
              d="M518 596c13,0 27,19 27,46 0,27 -14,46 -27,46 -13,0 -27,-19 -27,-46 0,-27 14,-46 27,-46zm0 -15l0 0c-23,0 -43,27 -43,61 0,34 20,62 43,62 24,0 43,-28 43,-62 0,-34 -19,-61 -43,-61z"/>
        <path style={ styles.col1 }
              d="M622 596c13,0 27,19 27,46 0,27 -14,46 -27,46 -12,0 -27,-19 -27,-46 0,-27 15,-46 27,-46zm0 -15l0 0c-23,0 -42,27 -42,61 0,34 19,62 42,62 24,0 43,-28 43,-62 0,-34 -19,-61 -43,-61z"/>
        <polygon style={ styles.col1 }
                 points="417,193 417,125 267,211 417,298 417,231 693,231 693,514 732,514 732,193 "/>
        <polygon style={{ fill: color }}
                 points="578,154 578,0 0,0 0,424 578,424 578,270 546,270 546,392 31,392 31,31 546,31 546,154 "/>
    </svg>
)

entranceDiSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

entranceDiSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default entranceDiSVG
